import * as yup from 'yup'

import { IProfileFormProps, IProfileNavigation } from 'features/Profile'

type Context = yup.TestContext & { type?: string }

export const initialForm: IProfileFormProps = {
  id: '',
  code: '',
  nickname: '',
  firstName: '',
  lastName: '',
  countryCode: '+66',
  phoneNumber: '',
  email: '',
  role: '',
  imagePath: '',
}

export const initProfileNavigation: IProfileNavigation = {
  id: '',
  firstName: '',
  lastName: '',
  imagePath: '',
}

export const schemaForm = yup.object().shape({
  code: yup.string().required('profile:staffId.error'),
  nickname: yup.string().required('profile:nickname.error'),
  firstName: yup.string().required('profile:firstName.error'),
  lastName: yup.string().required('profile:lastName.error'),
  countryCode: yup.string(),
  phoneNumber: yup
    .string()
    .max(15)
    .test('phoneNumber', async (phoneNumber, context: Context) => {
      const { path, resolve, createError } = context

      const isPhoneOffice =
        phoneNumber?.startsWith('02') &&
        phoneNumber?.replace('-', '').length !== 9
      const isPhoneNormal =
        !phoneNumber?.startsWith('02') &&
        phoneNumber?.replace('-', '').length !== 10

      if (phoneNumber && (isPhoneOffice || isPhoneNormal)) {
        return createError({
          path,
          message: 'profile:phone.invalid',
        })
      }

      return resolve(true)
    }),
  email: yup.string().max(50).email('common:emailInvalid.label'),
  role: yup.string().required('profile:role.error'),
})
